import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'astroturf/react'
const colorSurfaceWarning = 'var(--colorSurfaceWarning, var(--coreColorOrange200))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorTextInverseWarning = 'var(--colorTextInverseWarning, var(--coreColorOrange300))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
import { isSupportedCountry } from '@calendly/telephone-tools'

import { useI18n } from 'locales'
import BookingField from 'components/enter_details/booking_field'
import { EnterDetailsFieldset } from 'components/enter_details/form_field_spacing'
import PhoneField from 'components/form/phone'
import { dismissValidationError } from 'actions/errors'
import { inviteeTextReminderErrorsSelector } from 'selectors'

import { SmsLegalDisclaimer } from './sms_legal_disclaimer'
import _SMSDisclaimer from "text_reminder-SMSDisclaimer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/text_reminder.js?styleId=SMSDisclaimer";
import _StyledSmsLegalDisclaimer from "text_reminder-StyledSmsLegalDisclaimer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/text_reminder.js?styleId=StyledSmsLegalDisclaimer";
import _SMSWarning from "text_reminder-SMSWarning.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/text_reminder.js?styleId=SMSWarning";
import _WarningBadge from "text_reminder-WarningBadge.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/text_reminder.js?styleId=WarningBadge";


const SMSDisclaimer = /*#__PURE__*/styled('div', null, {
  displayName: "SMSDisclaimer",
  styles: _SMSDisclaimer
})

const StyledSmsLegalDisclaimer = /*#__PURE__*/styled(SmsLegalDisclaimer, null, {
  displayName: "StyledSmsLegalDisclaimer",
  styles: _StyledSmsLegalDisclaimer
})

const SMSWarning = /*#__PURE__*/styled('div', null, {
  displayName: "SMSWarning",
  styles: _SMSWarning
})

const WarningBadge = /*#__PURE__*/styled('div', null, {
  displayName: "WarningBadge",
  styles: _WarningBadge
})

const TextReminder = ({
  value = '',
  required,
  onChange
}) => {
  const { i18n } = useI18n()
  const [countryCode, setCountryCode] = useState(null)
  const [phoneNumberValid, setPhoneNumberValid] = useState(false)
  const dispatch = useDispatch()
  const dismissError = () => {
    dispatch(dismissValidationError('invitee', 'phone_number'))
  }
  const errors = useSelector(inviteeTextReminderErrorsSelector)
  const showCountryNotSupported = phoneNumberValid && !isSupportedCountry(countryCode)

  const onPhoneNumberChange = useCallback((phoneNumberInfo) => {
    const { countryCode: countryIso2, isValid } = phoneNumberInfo
    const code = countryIso2 ? countryIso2.toUpperCase() : null
    setCountryCode(code)
    setPhoneNumberValid(isValid)
    onChange(phoneNumberInfo)
  }, [onChange])

  return (
    <EnterDetailsFieldset>
      <BookingField>
        <PhoneField
          label={i18n.t('booking.templates.send_text_messages_to')}
          name="phone_number"
          number={value}
          required={required}
          hasWarning={showCountryNotSupported}
          error={errors?.[0]}
          onFocus={dismissError}
          onChange={onPhoneNumberChange}
        />
        {showCountryNotSupported
          && (
          <SMSWarning>
            <WarningBadge>!</WarningBadge>
            {' '}
            {i18n.t(`booking.templates.country_not_supported.${countryCode.toLowerCase()}`)}
          </SMSWarning>
          )}
        {['US', 'NZ'].includes(countryCode)
          && (
          <SMSDisclaimer>
            {i18n.t('booking.templates.you_will_opt_in')}
          </SMSDisclaimer>
          )}
        <StyledSmsLegalDisclaimer />
      </BookingField>
    </EnterDetailsFieldset>
  )
}

TextReminder.propTypes = {
  value: PropTypes.string,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
}

export default TextReminder
